import { createDeepMemoizedSelector } from 'utils/reduxUtils';

import { types } from './actions';

const initialState = {
  cachedContacts: [],
  isSearching: false,
  searchResults: [],
  searchTerm: '',
  count: 0,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.CONTACT_SEARCH_ERROR:
      return {
        ...state,
        isSearching: false,
      };
    case types.CONTACT_SEARCH_REQUEST:
      return {
        ...state,
        searchTerm: payload.search,
        isSearching: true,
      };
    case types.CONTACT_SEARCH_SUCCESS:
      return {
        ...state,
        isSearching: false,
        searchResults: payload.searchResults,
        count: payload.count,
      };
    case types.FETCH_CONTACT_SUCCESS:
      return {
        ...state,
        cachedContacts: [...state.cachedContacts, payload.contact],
      };
    case types.PAGINATE_CONTACT_REQUEST:
      return {
        ...state,
        isSearching: true,
      };
    case types.PAGINATE_CONTACT_SUCCESS:
      return {
        ...state,
        isSearching: false,
        searchResults: [...state.searchResults, ...payload.searchResults],
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) =>
  state.modules.common.smartComponents.contactSelector;

export const getCachedContacts = createDeepMemoizedSelector(
  (state) => getScope(state).cachedContacts,
  (cachedContacts) => cachedContacts,
);

export const getSearchResults = createDeepMemoizedSelector(
  (state) => getScope(state).searchResults,
  (searchResults) => searchResults,
);

export const getIsSearching = (state) => getScope(state).isSearching;

export const getSearchTerm = (state) => getScope(state).searchTerm;

export const getResultCount = (state) => getScope(state).count;
